module.exports = "/assets/packs/images/eadf5d851db138f16151929e9512dbcf.jpg";